import logout from "@/util/logout";
import store from "../../store";
import messages from "../../languages/index";
let lang = localStorage.getItem("language") || store.state.language || "pt";
// ###
// OperatorType
// Retail 0 - Não tem agente, 100 % online (Não tem agentes, Arrecadador, só venda online)

// Retail 1 - Simplificado(Não tem rotas, Arrecadadores, Agentes,
//            Lançamentos, crédito,
//            na Prestação de contas não tem 'Apuração Rotas',
//            Rotas dos agentes)

// Retail 2 - Completo(Agentes, Arrecadadores, rotas...)
// ###
// ###
// Credit - Módulo Crédito
// Credit 1 - Vende crédito no dinheiro com o agente
// Credit 2 - Venda Crédito Online
// ###
var operatorType = localStorage.getItem("operator-retail");
var credit = localStorage.getItem("operator-credit");

const operator = {
  operatorType: operatorType,
  credit: credit,
};
// Debugg
// const operator = {
//   operatorType: 2,
//   credit: 1,
// }
// console.log("operator na rota", operator)
export default {
  name: "localManager",
  path: "/local-manager",
  redirect: {
    name: "LocalManagerDashboard",
  },
  meta: {
    requiresAuth: true,
    nameDrawer: "Gerente Local",
  },
  component: () => import("@/views/backoffice/template.vue"),
  beforeEnter: (to, from, next) => {
    const { level } = localStorage;
    level == "localManager" ? next() : logout();
  },
  children: [
    //  =================================================================
    //  Group: Dashboard
    //  =================================================================
    {
      name: "LocalManagerDashboard",
      path: "dashboard",
      meta: {
        nameDrawer: "Dashboard",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator: true,
      },
      component: () =>
        import("@/views/backoffice/local-manager/dashboard/home"),
    },

    // Affiliates
    {
      name: "LocalManagerAffiliates",
      path: "affiliates",
      meta: {
        nameDrawer: messages[lang].affiliates,
        icon: "mdi-account-group",
        operator: operator.credit == 2 ? true : false,
        filters: ["Range", "GroupExport"],
        filterLimitDays: 31,
      },
      component: () =>
        import(
          "@/views/backoffice/local-manager/accountabilityOnline/"
        ),
      children: [
        {
          name: "LocalManagerAffiliatesExtract",
          path: "extract",
          redirect: {
            name: "LocalManagerAffiliatesRenevueShare"
          },
          meta: {
            nameDrawer: messages[lang].extract,
          },
          component: () =>
            import(
              "@/views/backoffice/local-manager/accountabilityOnline/extractAndCpa/"
            ),
          children: [
            {
              name: "LocalManagerAffiliatesRenevueShare",
              path: "revenueShare",
              meta: {
                nameDrawer: "Revenue Share",
                filters: ["Range", "GroupExport"],
                filterLimitDays: 31
              },
              component: () =>
                import(
                  "@/views/backoffice/local-manager/accountabilityOnline/extractAndCpa/extract/"
                )
            },
            {
              name: "LocalManagerAffiliatesCpa",
              path: "cpa",
              meta: {
                nameDrawer: "CPA",
                filters: [
                  "Range",
                  "AutocompleteAgents",
                  "GroupExport"
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/local-manager/accountabilityOnline/extractAndCpa/cpa/"
                )
            }
          ]
        },
      ],
    },

    //  =================================================================
    //  Group: Bet
    //  =================================================================
    {
      name: "LocalManagerBet",
      path: "bet",
      meta: {
        nameDrawer: messages[lang].bets,
        operator: true,
        icon: "mdi-ticket-confirmation",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/local-manager"),
      children: [
        {
          name: "LocalManagerBetHistoric",
          path: "historic",
          meta: {
            nameDrawer: messages[lang].historic,
            operator: true,
            filters: [
              "Range",
              "AutocompleteAgents",
              "SelectResultBet",
              "SelectStatusBet",
              "EventNumber",
            ],
            filterLimitDays: 15,
          },
          component: () =>
            import("@/views/backoffice/local-manager/bet/historic"),
          children: [
            {
              name: "LocalManagerBetHistoricAgent",
              path: ":id_agent",
              meta: {
                nameDrawer: messages[lang].historyLocalBettingManager,
              },
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Credit
    //  =================================================================
    {
      name: "LocalManagerCredit",
      path: "credit",
      meta: {
        nameDrawer: messages[lang].credit,
        operator: operator.operatorType == 2 ? true : false,
        icon: "mdi-credit-card-outline",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/local-manager"),
      children: [
        {
          name: "LocalManagerCreditHistoric",
          path: "historic",
          meta: {
            nameDrawer: messages[lang].historic,
            operator: true,
            filters: ["Range", "AutocompleteAgents", "GroupStatus"],
            filterLimitDays: 15,
          },
          component: () =>
            import("@/views/backoffice/local-manager/credit/historic"),
          children: [
            {
              name: "LocalManagerCreditHistoricAgent",
              path: ":id_agent",
              meta: {
                nameDrawer: messages[lang].agentCreditHistory,
              },
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Users (only Agents)
    //  =================================================================
    {
      name: "LocalManagerUsers",
      path: "users",
      meta: {
        nameDrawer: messages[lang].agents,
        operator:
          operator.operatorType == 2 || operator.operatorType == 1
            ? true
            : false,
        icon: "mdi-account-multiple",
        group: true,
        filters: ["SelectStatus"],
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/local-manager"),
      children: [
        {
          name: "LocalManagerUsersList",
          path: "list",

          meta: {
            nameDrawer: messages[lang].agentsList,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/local-manager/users/list"),
          children: [
            {
              name: "LocalManagerUserCreate",
              path: "update",
              meta: {
                nameDrawer: messages[lang].newAgent,
                hide: true,
              },
              component: () =>
                import("@/views/backoffice/local-manager/users/update"),
              children: [
                {
                  name: "LocalManagerUserEdit",
                  path: ":id",
                  meta: {
                    nameDrawer: messages[lang].editAgent,
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Financial
    //  =================================================================
    // {
    //   name: "LocalManagerFinancial",
    //   path: "financial",
    //   meta: {
    //     nameDrawer: messages[lang].accountability,
    //     operator: true,
    //     // icon: "mdi-cash-usd-outline",
    //     icon: "mdi-currency-usd",
    //     group: true,
    //   },
    //   //Index (router-view)
    //   component: () => import('@/views/backoffice/local-manager'),
    //   children: [{
    //     name: "LocalManagerFinancialApuration",
    //     path: "apuration",
    //     meta: {
    //       nameDrawer: messages[lang].generalFinding,
    //       operator: true,
    //       fluid: true,
    //       filters: [
    //         "Range",
    //         "AutocompleteAgents",
    //         "GroupExport"
    //       ],
    //       filterLimitDays: 31
    //     },
    //     component: () => new Promise((resolve) => {
    //       // store.state.operator.retail == 2 ?
    //       operator.operatorType == 2 ?
    //         resolve(import("@/views/backoffice/local-manager/financial/apuration")) :
    //         resolve(import("@/views/backoffice/local-manager/financial/apurationSimplified"))
    //     }),
    //   }, ],
    // },

    {
      name: "LocalManagerFinancial",
      path: "financial",
      meta: {
        nameDrawer: messages[lang].accountability,
        // icon: "mdi-cash-usd-outline",
        icon: "mdi-currency-usd",
        operator:
          operator.operatorType == 2 || operator.operatorType == 1
            ? true
            : false,
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/local-manager"),
      children: [
        {
          name: "LocalManagerFinancialApuration",
          path: "apuration",
          meta: {
            nameDrawer: messages[lang].generalFinding,
            operator: true,
            fluid: true,
            filters: ["Range", "AutocompleteAgents", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            new Promise((resolve) => {
              operator.operatorType == 2
                ? resolve(
                    import(
                      "@/views/backoffice/local-manager/financial/apuration"
                    )
                  )
                : resolve(
                    import(
                      "@/views/backoffice/local-manager/financial/apurationSimplified"
                    )
                  );
            }),
        },

        // Agents
        {
          name: "LocalManagerFinancialAgents",
          path: "agents",
          meta: {
            nameDrawer: messages[lang].agents,
            operator: operator.operatorType == 2 ? true : false,
            hide: true,
            subGroup: true,
          },
          component: () => import("@/views/backoffice/local-manager"),
          children: [
            {
              name: "LocalManagerBalance",
              path: "balance",
              meta: {
                nameDrawer: messages[lang].balanceReport,
                operator: true,
                fluid: true,
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/local-manager/financial/agents/balance"
                ),
              children: [
                {
                  name: "LocalManagerFinancialAgentsBalanceExtractAgent",
                  path: "extract/:id_agent_extract",
                  meta: {
                    nameDrawer: messages[lang].extractAgent,
                    operator: true,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/local-manager/financial/agents/extractAgent"
                    ),
                },
              ],
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Account
    //  =================================================================
    {
      name: "LocalManagerAccount",
      path: "account",
      meta: {
        nameDrawer: messages[lang].accountDrawer,
        operator: true,
        icon: "mdi-badge-account-horizontal",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/local-manager"),
      children: [
        {
          name: "LocalManagerAccountChangePassword",
          path: "changePassword",
          meta: {
            operator: true,
            nameDrawer: messages[lang].changePassword,
          },
          component: () =>
            import("@/views/backoffice/shared/account/changePassword.vue"),
        },
      ],
    },

    // Group: Config
    // {
    //   name: "LocalManagerConfig",
    //   path: "config",
    //   meta: {
    //     nameDrawer: "Configurações",
    //     icon: "mdi-cog",
    //   },
    //   //Index (router-view)
    //   component: () => import('@/views/backoffice/local-manager'),
    //   children: [
    //     {
    //       name: "LocalManagerConfigNetworkPrinting",
    //       path: "networkPrinting",
    //       meta: { nameDrawer: "Impressão em rede" },
    //       component: () => import("@/views/backoffice/local-manager/config/networkPrinting"),
    //     }
    //   ],
    // }
  ],
};
